import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { portfolioApiSelectors } from '../../api/portfolio'
import Label, { LabelProps } from '../../../views/components/atoms/Label/Label'
import { LEASE_STATUS_COLOR_OPACITY, getLeaseStatusColor } from '../leaseStatus'
import { $TSFixMe } from 'types/ts-migrate'

type Status = 'renewal' | 'expired' | 'terminated' | 'deleted' | 'expiring' | 'active' | 'draft'

type PortfolioStatusLabelProps<C extends React.ElementType> = {
  className?: string
  portfolioId?: string
  status?: Status
  statusPrefix?: string
  statusSuffix?: string
  useSummary?: boolean
  labelProps?: LabelProps<C>
}

const PortfolioStatusLabel = ({
  className,
  portfolioId,
  status,
  statusPrefix,
  statusSuffix,
  useSummary = false,
  labelProps,
}: PortfolioStatusLabelProps<$TSFixMe>) => {
  const portfolioStatus: $TSFixMe = useSelector(state =>
    portfolioApiSelectors.getPortfolioStatusLabel(state)(portfolioId, useSummary),
  )

  const statusLabel = status || portfolioStatus

  // Shared with the leases list's status markers, so a badge and a marker can't drift apart.
  const backgroundColor = useMemo(() => getLeaseStatusColor(statusLabel), [statusLabel])

  const style = {
    color: 'white',
    opacity: LEASE_STATUS_COLOR_OPACITY,
    backgroundColor,
  }

  return (
    statusLabel && (
      <Label circular style={style} className={className} {...labelProps}>
        {statusPrefix && `${statusPrefix} `}
        {statusLabel}
        {statusSuffix && ` ${statusSuffix}`}
      </Label>
    )
  )
}

export default PortfolioStatusLabel
